import {
  Component,
  ViewEncapsulation
} from "@angular/core";
import '@fitnesspassport/wc-visitation-report';
import { environment } from 'src/environments/environment';

@Component({
  selector: "app-visitation-trends",
  templateUrl: "./visitation-trends.component.html",
  styleUrls: ["./visitation-trends.component.css"],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class VisitationTrendsComponent {
  public environment: string; 
  public apiUrl: string; 

  constructor() {
    this.environment = environment.appConfig.environment;
    this.apiUrl = environment.facilitiesGraphApiUrl;
  }
}
